import { handleActions } from 'redux-actions';
import * as Actions from '../actions/mypageActions';

const DEFAULT_SCHOOL_EXTRA_CLASS = {
  id: 0,
  status_string: '',
  date_time: '',
  absent_date: '',
  added_school_attendance_id: null,
};

const DEFAULT_SCHOOL_ATTENDANCE = {
  id: 0,
  status_string: '',
  date_time: '',
  reason: '',
  comment: '',
  tooltip: false,
};

const app = handleActions({
  [Actions.setSchoolAttendances]: (state, action) => ({
    ...state,
    schoolAttendances: action.payload,
  }),
  [Actions.setSchoolXAttendances]: (state, action) => ({
    ...state,
    schoolXAttendances: action.payload,
  }),
  [Actions.updateSchoolAttendance]: (state, action) => ({
    ...state,
    schoolAttendances: state.schoolAttendances.map((x) => (x.id === action.payload.id ? { ...action.payload, date_time: x.date_time } : x)),
  }),
  [Actions.updateSchoolXAttendance]: (state, action) => ({
    ...state,
    schoolXAttendances: state.schoolXAttendances.map((x) => (x.id === action.payload.id ? { ...action.payload, date_time: x.date_time } : x)),
  }),
  [Actions.setAbsenceReasons]: (state, action) => ({
    ...state,
    absenceReasons: action.payload,
  }),
  [Actions.toggleAbsentModal]: (state, action) => ({
    ...state,
    openAbsentModal: !state.openAbsentModal,
    selectedSchoolAttendance: action.payload === undefined ? DEFAULT_SCHOOL_ATTENDANCE : action.payload,
  }),
  [Actions.setOpenCommentForm]: (state, action) => ({
    ...state,
    openCommentForm: action.payload,
  }),
  [Actions.setAbsentSucceed]: (state, action) => ({
    ...state,
    absentSucceed: action.payload,
  }),
  [Actions.toggleCancelAbsentSucceedModal]: (state) => ({
    ...state,
    openCancelAbsentSucceseedModal: !state.openCancelAbsentSucceseedModal,
  }),
  [Actions.setCancelAbsentSubmitting]: (state, action) => ({
    ...state,
    cancelAbsentSubmitting: action.payload,
  }),
  [Actions.toggleTooltip]: (state, action) => ({
    ...state,
    schoolAttendances: state.schoolAttendances.map((x) => (x.id === action.payload ? { ...x, tooltip: !x.tooltip } : x)),
  }),
  [Actions.setSchoolExtraClasses]: (state, action) => ({
    ...state,
    schoolExtraClasses: action.payload,
  }),
  [Actions.setPreAbsences]: (state, action) => ({
    ...state,
    preAbsences: action.payload,
  }),
  [Actions.toggleSchoolExtraClassModal]: (state, action) => ({
    ...state,
    selectedSchoolExtraClass: action.payload === undefined ? DEFAULT_SCHOOL_EXTRA_CLASS : action.payload,
    openSchoolExtraClassModal: !state.openSchoolExtraClassModal,
  }),
  [Actions.setAddSchoolExtraClassSucceed]: (state, action) => ({
    ...state,
    addSchoolExtraClassSucceed: action.payload,
  }),
  [Actions.updateSchoolExtraClass]: (state, action) => ({
    ...state,
    schoolExtraClasses: state.schoolExtraClasses.map((x) => (x.id === action.payload.id ? {
      ...x,
      status_string: action.payload.status_string,
      absent_date: action.payload.absent_date,
      added_school_attendance_id: action.payload.added_school_attendance_id,
    } : x)),
  }),
  [Actions.updatePreAbsence]: (state, action) => ({
    ...state,
    preAbsences: state.preAbsences.map((x) => (x.id === action.payload.id ? {
      ...x,
      disabled: action.payload.disabled,
    } : x)),
  }),
  [Actions.setCancelSchoolExtraClassSubmitting]: (state, action) => ({
    ...state,
    cancelSchoolExtraClassSubmitting: action.payload,
  }),
  [Actions.toggleCancelExtraClassSucceedModal]: (state) => ({
    ...state,
    openCancelExtraClassSucceedModal: !state.openCancelExtraClassSucceedModal,
  }),
}, {
  openAbsentModal: false,
  selectedSchoolAttendance: DEFAULT_SCHOOL_ATTENDANCE,
  absentSucceed: false,
  openCommentForm: false,
  openCancelAbsentSucceseedModal: false,
  schoolAttendances: [],
  schoolXAttendances: [],
  absenceReasons: [],
  cancelAbsentSubmitting: false,
  schoolExtraClasses: [],
  selectedSchoolExtraClass: DEFAULT_SCHOOL_EXTRA_CLASS,
  preAbsences: [],
  openSchoolExtraClassModal: false,
  addSchoolExtraClassSucceed: false,
  cancelSchoolExtraClassSubmitting: false,
  openCancelExtraClassSucceedModal: false,
});

export default app;
